export const DISPLAY_FORMAT = 'L';
export const ISO_FORMAT = 'YYYY-MM-DD';
export const ISO_MONTH_FORMAT = 'YYYY-MM';
export const DATE_TIME_FORMAT = 'DD MMMM YYYY HH:mm';
export const DATE_TIME_SHORT_FORMAT = 'DD/MMM/YYYY HH:mm';
export const DATE_LONG_FORMAT = 'dddd, DD MMMM YYYY';

export const WEEKDAYS = [0, 1, 2, 3, 4, 5, 6];

export const WEEKDAY_SHORT_NAMES = [
  'Sun',
  'Mon',
  'Tue',
  'Wed',
  'Thu',
  'Fri',
  'Sat'
];

export const MONTH_SHORT_NAMES = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec'
];

export const DURATION_SINGLE_DAY = 'single';
export const DURATION_MULTIPLE_DAYS = 'multiple';

export const UNIT_HOURS = 0;
export const UNIT_DAYS = 1;

export const DAY_TYPE_FULL = 0;
export const DAY_TYPE_FIRST_HALF = 1;
export const DAY_TYPE_SECOND_HALF = 2;
export const DAY_TYPE_SPECIFIC_TIME = 3;

export const UNIT_NAMES = ['Hours', 'Days'];

export const CLOCK_IN_ACTION = 'Clock In';
export const CLOCK_OUT_ACTION = 'Clock Out';
export const LUNCH_START_ACTION = 'Lunch Start';
export const LUNCH_END_ACTION = 'Lunch End';
export const CHANGE_PAY_CATEGORY_ACTION = 'Pay Category';
export const CHANGE_JOB_ACTION = 'Change Job';

export const CLOCKED_IN_STATUS = 0;
export const CLOCKED_TO_LUNCH_STATUS = 1;
export const CLOCKED_IN_AFTER_LUNCH_STATUS = 2;
export const CLOCKED_TO_TEA_BREAK_STATUS = 3;
export const CLOCKED_OUT_STATUS = 4;
export const CLOCKING_PENDING_STATUS = 5;
